import { withDependencies } from '@wix/thunderbolt-ioc'
import type { INavigationManager } from '../types'
import { NavigationManagerSymbol, name as navigationManagerFeatureName } from '../symbols'
import { IDataRequirementsChecker } from '@wix/thunderbolt-symbols'

export const NavigationChecker = withDependencies(
	[NavigationManagerSymbol],
	(navigationManager: INavigationManager): IDataRequirementsChecker => {
		return {
			featureName: navigationManagerFeatureName,
			pendingRequirements: async () => {
				if (navigationManager.isDuringDataFetching()) {
					await navigationManager.waitForDataFetching()
				}

				if (navigationManager.isDuringNavigation()) {
					await navigationManager.waitForNavigationEnd()
				}
			},
		}
	}
)
